<ng-container *transloco="let t; read: 'authentication'">
  <div
    role="button"
    tabindex="0"
    [attr.aria-label]="t('PASSWORD_SIGN_IN')"
    (click)="clickEvent.emit()"
    (keyup.enter)="clickEvent.emit()"
    (keyup.space)="clickEvent.emit()"
  >
    <mat-icon class="material-symbols-outlined" title="{{ t('PASSWORD_LOGO') }}">mail</mat-icon>
    <span>{{ t('PASSWORD_SIGN_IN') }}</span>
  </div>
</ng-container>
